import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React__default, { useMemo } from 'react';
import { VariableSizeList } from 'react-window';
import useScrollCapture from '../../../../hooks/useScrollCapture/useScrollCapture.js';
import 'react-highlight-words';

const TopShadow = styled(MuiBox, {
    shouldForwardProp: prop => !['show'].includes(prop),
}) `
  position: absolute;
  background: ${({ theme }) => `linear-gradient(180deg, ${theme.palette.dropShadow.main} 0% , rgba(24, 30, 39, 0) 100%);`}
  width: 100%;
  height: 16px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  z-index: 10;
  transition: opacity ${({ theme }) => theme.transitions.duration.slow} ease-in-out;
`;
const BottomShadow = styled(TopShadow) `
  bottom: 0;
  transform: rotate(180deg) !important;
`;
const _TableList = styled(VariableSizeList) `
  ${({ disabled }) => disabled &&
    `
    opacity: 0.3;
    pointer-events: none;
  `}
`;
const TableList = React__default.forwardRef((_a, ref) => {
    var { children, width, listRef } = _a, rest = __rest(_a, ["children", "width", "listRef"]);
    const { scrollRef, scrollPosition } = useScrollCapture(true);
    const showTop = useMemo(() => {
        return scrollPosition === 'top' || scrollPosition === 'middle';
    }, [scrollPosition]);
    const showBottom = useMemo(() => {
        return scrollPosition === 'bottom' || scrollPosition === 'middle';
    }, [scrollPosition]);
    const widthWitoutScrollbar = useMemo(() => (isNaN(width) ? width : Number(width) - 16), [width]);
    return (jsxs(Fragment, { children: [jsx(TopShadow, { maxWidth: widthWitoutScrollbar, show: showBottom }), jsx(BottomShadow, { maxWidth: widthWitoutScrollbar, show: showTop }), jsx(_TableList, Object.assign({ innerRef: ref, ref: listRef, outerRef: scrollRef, width: width }, rest, { scrollPosition: scrollPosition, style: { overflowX: 'hidden' } }, { children: children }))] }));
});
TableList.displayName = 'TableList';

export { TableList as default };
//# sourceMappingURL=TableList.js.map
